export default {
  messages: {
    en: {
      entireRemaining: 'Entire amount',
      submit: 'Lend',
    },
  },
}
